import { useTranslation } from 'react-i18next'
import { TaskChecklistSection } from './TaskChecklistSection'

interface Props {
  taskId: string
  completed: number
  total: number
  readOnly?: boolean
}

export function TaskChecklistCard({
  taskId,
  completed,
  total,
  readOnly = false,
}: Props) {
  const { t } = useTranslation('tasks')

  return (
    <section className='overflow-hidden rounded-2xl border border-[#e7e9ef] bg-white shadow-[0_1px_8px_-1px_rgba(38,45,66,0.10),0_1px_4px_-1px_rgba(38,45,66,0.05)]'>
      <div className='flex h-12 items-center pt-4'>
        <div className='flex min-w-0 flex-1 items-center gap-2 border-l-4 border-[#ff5a1f] px-6'>
          <h2 className='min-w-0 flex-1 font-heading text-base font-semibold leading-[1.2] text-[#171a20]'>
            {t('checklist.title')}
          </h2>
          <span className='inline-flex h-6 shrink-0 items-center rounded-lg bg-[#e7e9ef] px-2 py-1 text-xs font-medium leading-4 text-[#171a20]'>
            {t('checklist.progress', { completed, total })}
          </span>
        </div>
      </div>
      <TaskChecklistSection taskId={taskId} readOnly={readOnly} />
    </section>
  )
}

export default TaskChecklistCard
